// import searchChildren from './searchChildren';
function sortObjects(flatArray, hierarchicalArray) {

	// flatArray item.value = string term_id
	// hierarchicalArray item.term_id = int term_id

	// create a mapping of term_id to objects in the second array for faster lookup
	const hierarchicalArrayMap = {};
	for (let obj of hierarchicalArray) {
	  hierarchicalArrayMap[obj.term_id] = obj;
	}
	
	const emptyParents = [];
	const emptyChildren = [];
  
	// iterate through the first array and check if the value exists in the second array
	const result = [];
	for (let obj of flatArray) {
		if (hierarchicalArrayMap[Number(obj.value)]) {
			const commonObj = Object.assign({}, obj);
			commonObj.term_id = obj.value;
			commonObj.label = hierarchicalArrayMap[Number(obj.value)].title;
			commonObj.children = [];
			commonObj.id = hierarchicalArrayMap[Number(obj.value)].title.replace(/\s+/g, "-").toLowerCase();
			result.push(commonObj);
		} else {
			// iterate through the second array and check if the value exists in the children
			for (let hierarchicalObj of hierarchicalArray) {
				const children = hierarchicalObj.children;
				if (children) {
					for( let child of children ) {
						if (child.term_id == obj.value) {
							// iterate through the result array and check if an object with the term_id property matching hierarchicalObj.term_id exists without using searchChildren
							const parent = result.find((item) => item.term_id == hierarchicalObj.term_id);
	
							// if not, add it
							if (!parent || typeof parent === "undefined") {
								emptyParents.push(hierarchicalObj);
								const childObj = Object.assign({}, obj);
								childObj.parent = hierarchicalObj.term_id;
								childObj.label = child.title;
								emptyChildren.push(childObj);
							} else {
								const childObj = Object.assign({}, obj);
								childObj.parent = hierarchicalObj.term_id;
								childObj.label = child.title;
								parent.children.push(childObj);
							}
						}
					}
				}
			}
		}
	}

	// loop over emptyParents and add them to result if they don't already exist
	for (let hierarchicalObj of emptyParents) {
		// check if an item with the term_id property matching hierarchicalObj.term_id exists in result
		const parent = result.find((item) => item.term_id == hierarchicalObj.term_id);
		if ( ! parent || typeof parent === "undefined" ) {
			const commonObj = Object.assign({}, hierarchicalObj);
			commonObj.value = hierarchicalObj.term_id;
			commonObj.label = hierarchicalObj.title;
			commonObj.id = hierarchicalObj.title.replace(/\s+/g, "-").toLowerCase();
			commonObj.isRefined = false;
			commonObj.count = 0;
			result.push(commonObj);
		}
	}
	// loop over emptyChildren and add them to their parent in result if they don't already exist
	for (let obj of emptyChildren) {
		// check if an item with the term_id property matching obj.parent exists in result
		const parent = result.find((item) => item.term_id == obj.parent);
		if ( parent ) {
			parent.children.push(obj);
		}

	}
  
	return result;
  }

  export default sortObjects;